import React, { useEffect, useRef, useState } from "react";
import trash from "../../../../assets/center/images/trash.svg";
import { list, add, deleteStaff, edit, sortStaff, detail, changeStatus, deleteDoctor, deletePatient, editHealth, sendOTP, verifyOTP } from "../../services/patient.services";
import {
    ACTIVE,
    ACTIVITY_LEVEL,
    ALLERGIES,
    CRAVING_FOODS,
    CUISINE_PREFERENCE,
    DEACTIVE,
    DIET_TYPE,
    DRINKING_HABITS,
    GENDER,
    LOADER_TIMEOUT_TIME,
    MEAL_TIMES,
    MEDICAL_CONDITIONS,
    PHONE_NO_LENGTH,
    SLEEP_QUALITY,
    SMOKING_HABITS,
    SORT_A,
    SORT_D,
    SUGAR_TYPE,
    SWAL_SETTINGS,
} from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { Formik, useFormik, Field, Form } from "formik";
import { useValidationSchemas } from "../../../center/validator/validation";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter, globalLoader, handleOffcanvasScroll, handleServerValidations, removeSpecialCharacter, TrimText, useDebouncing } from "../../../../utils/commonfunction";
import CustomError from "../../../../utils/customError";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import RecordNotFound from "../../shared/recordNotFound";
import PhoneInput from "../../../../utils/PhoneInput";
import { DatePicker, Drawer, TagPicker } from "rsuite";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../../../admin/common/custompagination";

export default function Patient() {
    const navigate = useNavigate();
    const params = useParams();
    const { t } = useTranslation();
    const [List, setList] = useState([]);
    const { patientDoctorValidationSchema, editPatientDoctorValidationSchema } = useValidationSchemas();
    const addCategoryCloseBtn = useRef();
    const [refreshList, setRefreshList] = useState(false);
    const [openWithHeader, setOpenWithHeader] = useState(false);
    const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);
    const [prevGlobalSearch, setPrevGlobalSearch] = useState("");
    const [globalSearch, setGlobalSearch] = useState("");
    const [search, setSearch] = useState({});
    const [loader, setLoader] = useState(true);
    const [staffDetail, setStaffDetail] = useState({});
    const [page, setPage] = useState(1);
    const [offset, setOffsetPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [itemPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [sortConfig, setSortConfig] = useState({ column: "createdAt", order: SORT_D });
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
        params.page = 1;
    };

    const prepareGlobalSearch = (value) => {
        setPrevGlobalSearch(globalSearch);
        setGlobalSearch(value);
    };
    const searchDebounce = useDebouncing(prepareGlobalSearch);

    const handleFilterStatusChange = (e) => {
        if (e.target.value) {
            prepareSearch("status", Number(e.target.value));
        } else {
            prepareSearch("status", "");
        }
    };

    // Handle search input change
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);
        searchDebounce(value);
    };

    // Handle select dropdown change
    const handleSelectChange = (e) => {
        const value = e.target.value;
        setSelectedStatus(value);
        handleFilterStatusChange(e);
    };

    const handleSort = (key) => {
        let direction = SORT_A;
        if (sortConfig.column === key && sortConfig.order === SORT_A) {
            direction = SORT_D;
        }
        setSortConfig({ column: key, order: direction });
    };

    useEffect(() => {
        setLoader(true);
        const formData = new FormData();
        if (Object.keys(search).length) {
            formData.append("search", JSON.stringify(search));
        }
        formData.append("global_search", globalSearch);
        let page = params.page;
        if (globalSearch) {
            if (prevGlobalSearch !== globalSearch || !prevGlobalSearch) {
                page = 1;
            }
            setPage(page);
        }
        formData.append("page", page);
        formData.append("per_page", itemPerPage);
        if (sortConfig) {
            formData.append("sort", JSON.stringify(sortConfig));
        }
        list(formData)
            .then((data) => {
                if (data && data.data) {
                    setList(data.data.list || []);
                    setPage(data.data.page);
                    navigate(`/doctor/settings/patient/${data.data.page}`);
                    setOffsetPage(data.data.offset);
                    setTotalRecords(data.data.total_records || 0);
                } else {
                    setList([]);
                    setOffsetPage(0);
                    setTotalRecords(0);
                }
                setPrevGlobalSearch(globalSearch);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            })
            .catch((error) => {
                console.log("error ====> ", error);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            });
    }, [search, refreshList, globalSearch, params.page, sortConfig]);

    const getPatientDetail = (item) => {
        detail({ patient_id: item._id })
            .then((response) => {
                editForm.setValues({
                    o_id: response?.data?._id || "",
                    name: response?.data?.name || "",
                    email: response?.data?.email || "",
                    phone_number: response?.data?.phone_number || "",
                    dob: response?.data?.dob || "",
                    gender: response?.data?.gender || "",
                    address: response?.data?.address || "",
                    language_preference: response?.data?.language_preference || "",
                    blood_pressure: response?.data?.health_matrix?.blood_pressure || "",
                    sugar: response?.data?.health_matrix?.sugar || "",
                    sugar_type: response?.data?.health_matrix?.sugar_type || "",
                    pulse_rate: response?.data?.health_matrix?.pulse_rate || "",
                    sleep_pattern: response?.data?.health_matrix?.sleep_pattern || "",
                    height: response?.data?.health_matrix?.height || "",
                    weight: response?.data?.health_matrix?.weight || "",
                });
                setStaffDetail(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const d = new Date();
    const validDateLimit = d.setFullYear(d.getFullYear() - 1);

    const addForm = useFormik({
        initialValues: {
            name: "",
            email: "",
            phone_number: "",
            dob: "",
            gender: "",
            language_preference: "",
            address: "",
        },
        validationSchema: patientDoctorValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            const formData = new FormData();
            formData.append("name", values.name);
            formData.append("email", values.email.toLowerCase());
            formData.append("phone_number", values.phone_number);
            formData.append("dob", values.dob);
            formData.append("gender", values.gender);
            formData.append("language_preference", values.language_preference);
            formData.append("address", values.address);
            setAddSubmissionLoader(true);
            add(formData)
                .then((response) => {
                    setAddSubmissionLoader(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        setOpenWithHeader(false);
                        setRefreshList(!refreshList);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setAddSubmissionLoader(false);
                    console.error("Error updating profile", error);
                });
            console.log(values);
        },
    });

    const editForm = useFormik({
        initialValues: {
            o_id: "",
            name: "",
            email: "",
            phone_number: "",
            dob: "",
            gender: "",
            language_preference: "",
            address: "",
        },
        validationSchema: editPatientDoctorValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            setEditSubmissionLoader(true);
            const formData = new FormData();
            formData.append("o_id", staffDetail._id);
            formData.append("name", values.name);
            formData.append("email", values.email.toLowerCase());
            formData.append("phone_number", values.phone_number);
            formData.append("dob", values.dob);
            formData.append("gender", values.gender);
            formData.append("language_preference", values.language_preference);
            formData.append("address", values.address);
            edit(formData)
                .then((response) => {
                    console.log("response", response);
                    setEditSubmissionLoader(false);
                    if (response?.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        setOpenWithHeaderEdit(false);
                        setRefreshList(!refreshList);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setEditSubmissionLoader(false);
                    console.error("Error updating profile", error);
                });
            console.log(values);
        },
    });

    const deleteRecord = (item) => {
        Swal.fire({
            title: t("center.header.msg_are_you_sure"),
            text: t("center.staff.btn_delete_text"),
            imageUrl: trash,
            showCancelButton: true,
            confirmButtonColor: "#dc3545",
            cancelButtonColor: "#6c757d",
            confirmButtonText: t("center.button.btn_delete"),
            cancelButtonText: t("center.button.btn_cancel"),
            reverseButtons: true,
            customClass: {
                popup: "swal-restaurant",
                confirmButton: "btn btn-danger col",
                cancelButton: "btn btn-secondary col",
            },
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                globalLoader(true);
                deletePatient({ o_id: item._id })
                    .then((response) => {
                        globalLoader(false);
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setRefreshList(!refreshList);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        globalLoader(false);
                        console.log("deleteError");
                    });
            }
        });
    };

    const changeStatusToggle = (item) => {
        Swal.fire({
            title: t("center.header.msg_are_you_sure"),
            text: item.status ? "You want to deactive this patient!" : "You want to active this patient!",
            // imageUrl: trash,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#dc3545",
            cancelButtonColor: "#6c757d",
            confirmButtonText: item.status ? t("center.staff.btn_inactive") : t("center.staff.btn_active"),
            cancelButtonText: t("center.button.btn_cancel"),
            reverseButtons: true,
            customClass: {
                popup: "swal-restaurant",
                confirmButton: "btn btn-danger col",
                cancelButton: "btn btn-secondary col",
            },
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                globalLoader(true);
                changeStatus({ o_id: item._id, status: item.status ? DEACTIVE : ACTIVE })
                    .then((response) => {
                        globalLoader(false);
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setRefreshList(!refreshList);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        globalLoader(false);
                        console.log("deleteError");
                    });
            }
        });
    };

    const viewFunction = (item) => {
        navigate(`/doctor/patient/appointment/view/${item._id}`);
    };

    const medicalConditionData = MEDICAL_CONDITIONS.map((item) => ({
        label: capitalizeFirstLetter(item?.label),
        value: item?.value,
    }));

    const allergiesData = ALLERGIES.map((item) => ({
        label: capitalizeFirstLetter(item?.label),
        value: item?.value,
    }));

    const mealTimesData = MEAL_TIMES.map((item) => ({
        label: capitalizeFirstLetter(item?.label),
        value: item?.value,
    }));

    const activityLevelData = ACTIVITY_LEVEL.map((item) => ({
        label: capitalizeFirstLetter(item?.label),
        value: item?.value,
    }));

    const sleepQualityData = SLEEP_QUALITY.map((item) => ({
        label: capitalizeFirstLetter(item?.label),
        value: item?.value,
    }));

    const cuisinePreferenceData = CUISINE_PREFERENCE.map((item) => ({
        label: capitalizeFirstLetter(item?.label),
        value: item?.value,
    }));

    const carvingFoodsData = CRAVING_FOODS.map((item) => ({
        label: capitalizeFirstLetter(item?.label),
        value: item?.value,
    }));

    useEffect(() => {
        if (params.page && parseInt(params.page) !== 1) {
            navigate("/doctor/settings/patient/1", { replace: true });
        }
    }, []);

    return (
        <main id="main-content">
            <div className="inner-container">
                <div className="page-header d-flex align-items-center">{/* <h4 className="heading-title-text">{t("Doctors Management")}</h4> */}</div>
                <div className="card-outer-header d-flex justify-content-between align-items-center mb-4">
                    <div className="search-box">
                        <input type="text" value={searchValue} className="form-control search-input" placeholder={t("center.staff.input_placeholder_search")} onChange={handleSearchChange} />
                    </div>
                    <div className="card-head-group d-flex align-items-center gap-2">
                        <div className="tabls-dowpdown">
                            <select className="form-control cp" value={selectedStatus} onChange={handleSelectChange}>
                                <option disabled="" value="">
                                    {t("center.staff.label_select_status")}
                                </option>
                                <option value="1"> {t("center.staff.btn_active")}</option>
                                <option value="0">{t("center.staff.btn_inactive")}</option>
                            </select>
                        </div>
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                setOpenWithHeader(true);
                            }}
                        >
                            {t("Create Patient Profile")}
                        </button>
                    </div>
                </div>

                <div className="dashboard-content-wraper">
                    <div className="category-list-wrap">
                        <div className="card card-table">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>{t("center.staff.s_no")}</th>
                                                <th>{t("Patient ID")}</th>
                                                <th>
                                                    {t("Patient Name")}
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort("name")}>
                                                        <i
                                                            className={`ti ti-arrow-narrow-up ${sortConfig.column === "name" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "5px" }}
                                                        ></i>
                                                        <i
                                                            className={`ti ti-arrow-narrow-down ${sortConfig.column === "name" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "-8px" }}
                                                        />
                                                    </span>
                                                </th>
                                                <th>
                                                    {t("Email")}
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort("email")}>
                                                        <i
                                                            className={`ti ti-arrow-narrow-up ${sortConfig.column === "email" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "5px" }}
                                                        ></i>
                                                        <i
                                                            className={`ti ti-arrow-narrow-down ${sortConfig.column === "email" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "-8px" }}
                                                        />
                                                    </span>
                                                </th>
                                                <th>
                                                    {t("Gender")}
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort("gender")}>
                                                        <i
                                                            className={`ti ti-arrow-narrow-up ${sortConfig.column === "gender" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "5px" }}
                                                        ></i>
                                                        <i
                                                            className={`ti ti-arrow-narrow-down ${sortConfig.column === "gender" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "-8px" }}
                                                        />
                                                    </span>
                                                </th>
                                                <th>
                                                    Contact Number
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort("phone_number")}>
                                                        <i
                                                            className={`ti ti-arrow-narrow-up ${sortConfig.column === "phone_number" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "5px" }}
                                                        ></i>
                                                        <i
                                                            className={`ti ti-arrow-narrow-down ${sortConfig.column === "phone_number" && sortConfig.order === SORT_A ? "sort-disabled" : ""}`}
                                                            style={{ marginLeft: "-8px" }}
                                                        />
                                                    </span>
                                                </th>
                                                <th>{t("center.staff.list_heading_status")}</th>
                                                <th style={{ width: "150px" }}>{t("center.staff.label_action")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loader ? (
                                                <td className="text-center" colSpan={8}>
                                                    <Skeleton className="mb-2" height={50} count={5} />
                                                </td>
                                            ) : List?.length ? (
                                                List &&
                                                List.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{offset + index + 1}</td>
                                                            <td>{item?.patient_register_id ? "#" + item?.patient_register_id : "-"}</td>
                                                            <td>{capitalizeFirstLetter(TrimText(item?.name, 30))}</td>
                                                            <td>{item?.email || "-"}</td>
                                                            <td>{capitalizeFirstLetter(item?.gender)}</td>
                                                            <td>{item?.phone_number}</td>
                                                            <td>
                                                                <div className="mai-card-right">
                                                                    <div className="form-check form-switch">
                                                                        <input className="form-check-input cp" type="checkbox" checked={item?.status} onChange={(e) => changeStatusToggle(item)} />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="d-flex">
                                                                <div className="dropdown ms-2">
                                                                    <button
                                                                        className="btn btn-icon dropdown-toggle"
                                                                        type="button"
                                                                        id="dropdownMenuButton"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <i className="ti ti-dots-vertical"></i>
                                                                    </button>
                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                        <li>
                                                                            <a
                                                                                className="dropdown-item cp"
                                                                                //   onClick={() => {
                                                                                //       getPatientDetail(item);
                                                                                //   }}
                                                                                onClick={() => {
                                                                                    viewFunction(item);
                                                                                }}
                                                                                //   data-bs-toggle="offcanvas"
                                                                                //   data-bs-target="#view-staff"
                                                                            >
                                                                                <i className="ti ti-eye"></i>
                                                                                {t("center.button.btn_view")}
                                                                            </a>
                                                                        </li>
                                                                        <li>
                                                                            <a
                                                                                className="dropdown-item cp"
                                                                                onClick={() => {
                                                                                    getPatientDetail(item);
                                                                                    setOpenWithHeaderEdit(true);
                                                                                }}
                                                                            >
                                                                                <i className="ti ti-edit"></i>
                                                                                {t("center.button.btn_edit")}
                                                                            </a>
                                                                        </li>
                                                                        {/* <li>
                                                                          <a
                                                                              className="dropdown-item cp"
                                                                              onClick={() => {
                                                                                  deleteRecord(item);
                                                                              }}
                                                                          >
                                                                              <i className="ti ti-trash"></i>
                                                                              {t("center.button.btn_delete")}
                                                                          </a>
                                                                      </li> */}
                                                                        <li>
                                                                            <a
                                                                                className="dropdown-item cp"
                                                                                onClick={() => {
                                                                                    // navigate(`/center/settings/doctor/schedule/1`,{ state: { doctor_id: item?._id } });
                                                                                    // navigate(`/doctor/patient/appointment/1?patient_id=${item?._id}`);
                                                                                    navigate(`/doctor/patient/appointment/${item?._id}/1`);
                                                                                    //   navigate(`/doctor/patient/appointment/1`);
                                                                                }}
                                                                            >
                                                                                <i className="ti ti-calendar"></i>
                                                                                Appointments
                                                                            </a>
                                                                        </li>
                                                                        <li>
                                                                            <a
                                                                                className="dropdown-item cp"
                                                                                // onClick={() => {
                                                                                //     getPatientDetail(item);
                                                                                //     setOpenWithGenerateDietChartHeader(true);
                                                                                // }}
                                                                                //  onClick={() => {
                                                                                //       navigate(`/doctor/patient/diet-chart/add?patient_id=${item?._id}`);
                                                                                // }}
                                                                                onClick={() => {
                                                                                    navigate(`/doctor/patient/diet-chart/add?patient_id=${item?._id}`, {
                                                                                        state: { patientData: item },
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <i className="ti ti-clipboard-list"></i>
                                                                                Generate Diet Chart
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <td colSpan={8}>
                                                    <RecordNotFound heading="center.staff.no_staff_found" />
                                                </td>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="table-status-info d-flex justify-content-between align-items-center">
                                    <span>
                                        {t("center.staff.label_showing")} {offset + List.length} of {totalRecords} {t("center.staff.label_entries")}
                                    </span>
                                    <nav aria-label="Page navigation example" title={page}>
                                        {totalRecords && totalRecords > 0 ? (
                                            <CustomPagination
                                                datalength={totalRecords}
                                                itemperpage={itemPerPage}
                                                currentPage={page}
                                                custompath="page"
                                                setPage={setPage}
                                                pageRoute={[{ name: "settings", path: "/doctor/settings/patient" }]}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div></div>
            </div>

            {/* add item modal  */}
            <Drawer open={openWithHeader}>
                <Drawer.Header closeButton={false}>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        <h3 className="mb-0">{t("Create Patient")}</h3>
                        <button
                            className="btn-icon"
                            onClick={() => {
                                setOpenWithHeader(false);
                                addForm.resetForm();
                            }}
                        >
                            <i className="ri-close-fill"></i>
                        </button>
                    </div>
                </Drawer.Header>
                <Drawer.Body
                    onScroll={(e) => {
                        handleOffcanvasScroll(e, "editNewEmail", "rsuite");
                    }}
                >
                    <form onSubmit={addForm.handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Patient Name")}
                                <span>*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("Enter patient name")}
                                name="name"
                                value={addForm?.values?.name}
                                onChange={addForm.handleChange}
                                onBlur={addForm.handleBlur}
                            />
                            <CustomError name="name" form={addForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">{t("Email")}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("Enter email")}
                                name="email"
                                value={addForm?.values?.email}
                                onChange={addForm.handleChange}
                                onBlur={addForm.handleBlur}
                            />
                            {/* <CustomError name="email" form={addForm} className="text-danger" /> */}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                Phone Number
                                <span>*</span>
                            </label>
                            <PhoneInput
                                value={addForm?.values?.phone_number}
                                name={"phone_number"}
                                onChange={(e) => {
                                    addForm.setFieldValue("phone_number", e?.phone_number);
                                }}
                                placeholder={t("center.staff.placeholder_contact_number")}
                                onBlur={addForm.handleBlur}
                            />
                            <CustomError name="phone_number" form={addForm} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Gender")}
                                <span>*</span>
                            </label>
                            <select className="form-control cp" name="gender" value={addForm?.values?.gender} onChange={addForm.handleChange}>
                                <option value={""}>{t("Select")}</option>
                                {GENDER.map((item, index) => {
                                    return (
                                        <option key={index} value={item.value}>
                                            {item.label}
                                        </option>
                                    );
                                })}
                            </select>
                            {addForm.touched.gender && addForm.errors.gender ? <div className="text-danger">{t(addForm.errors.gender)}</div> : null}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("DOB")}
                                <span>*</span>
                            </label>
                            <DatePicker
                                oneTap={true}
                                classPrefix="restaurant"
                                placeholder={t("Enter DOB")}
                                placement="autoVertical"
                                format="dd.MM.yyyy"
                                cleanable={false}
                                name="dob"
                                onChange={(e) => {
                                    addForm.setFieldTouched("dob", true);
                                    addForm.setFieldValue("dob", e);
                                }}
                                value={new Date(addForm.values.dob)}
                                onBlur={addForm.handleBlur}
                                // shouldDisableDate={(date) => {
                                //     const today = new Date();
                                //     today.setHours(0, 0, 0, 0);
                                //     return date >= today;
                                // }}
                                shouldDisableDate={(date) => {
                                    const d = new Date();
                                    const validDateLimit = d.setFullYear(d.getFullYear() - 1);
                                    return date >= validDateLimit;
                                }}
                            />
                            <CustomError name="dob" form={addForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Language Preference")}
                                <span>*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("Enter language preference")}
                                name="language_preference"
                                value={addForm?.values?.language_preference}
                                onChange={addForm.handleChange}
                                onBlur={addForm.handleBlur}
                            />
                            <CustomError name="language_preference" form={addForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Location")}
                                <span>*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("Enter location")}
                                name="address"
                                value={addForm?.values?.address}
                                onChange={addForm.handleChange}
                                onBlur={addForm.handleBlur}
                            />
                            <CustomError name="address" form={addForm} className="text-danger" />
                        </div>
                        <div className="button-form">
                            <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}>
                                Create
                            </button>
                        </div>
                    </form>
                </Drawer.Body>
            </Drawer>

            <Drawer open={openWithHeaderEdit}>
                <Drawer.Header closeButton={false}>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        <h3 className="mb-0">{t("Edit Patient")}</h3>
                        <button
                            className="btn-icon"
                            onClick={() => {
                                setOpenWithHeaderEdit(false);
                                editForm.resetForm();
                            }}
                        >
                            <i className="ri-close-fill"></i>
                        </button>
                    </div>
                </Drawer.Header>
                <Drawer.Body
                    onScroll={(e) => {
                        handleOffcanvasScroll(e, "editEmail", "rsuite");
                    }}
                >
                    <form onSubmit={editForm.handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Patient Name")}
                                <span>*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("Enter patient name")}
                                name="name"
                                value={editForm?.values?.name}
                                onChange={editForm.handleChange}
                                onBlur={editForm.handleBlur}
                            />
                            <CustomError name="name" form={editForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">{t("Email")}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("Enter email")}
                                name="email"
                                value={editForm?.values?.email}
                                onChange={editForm.handleChange}
                                onBlur={editForm.handleBlur}
                            />
                            {/* <CustomError name="email" form={editForm} className="text-danger" /> */}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                Phone Number
                                <span>*</span>
                            </label>
                            <PhoneInput
                                value={editForm?.values?.phone_number}
                                name={"phone_number"}
                                onChange={(e) => {
                                    editForm.setFieldValue("phone_number", e?.phone_number);
                                }}
                                placeholder={t("center.staff.placeholder_contact_number")}
                                onBlur={editForm.handleBlur}
                            />
                            <CustomError name="phone_number" form={editForm} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Gender")}
                                <span>*</span>
                            </label>
                            <select className="form-control cp" name="gender" value={editForm?.values?.gender} onChange={editForm.handleChange}>
                                <option value={""}>{t("Select")}</option>
                                {GENDER.map((item, index) => {
                                    return (
                                        <option key={index} value={item.value}>
                                            {item.label}
                                        </option>
                                    );
                                })}
                            </select>
                            {editForm.touched.gender && editForm.errors.gender ? <div className="text-danger">{t(editForm.errors.gender)}</div> : null}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("DOB")}
                                <span>*</span>
                            </label>
                            <DatePicker
                                oneTap={true}
                                classPrefix="restaurant"
                                placeholder={t("Enter DOB")}
                                placement="autoVertical"
                                format="dd.MM.yyyy"
                                cleanable={false}
                                name="dob"
                                onChange={(e) => {
                                    editForm.setFieldTouched("dob", true);
                                    editForm.setFieldValue("dob", e);
                                }}
                                value={new Date(editForm.values.dob)}
                                onBlur={editForm.handleBlur}
                                // shouldDisableDate={(date) => {
                                //     const today = new Date();
                                //     today.setHours(0, 0, 0, 0);
                                //     return date >= today;
                                // }}
                                shouldDisableDate={(date) => {
                                    const d = new Date();
                                    const validDateLimit = d.setFullYear(d.getFullYear() - 1);
                                    return date >= validDateLimit;
                                }}
                            />
                            <CustomError name="dob" form={editForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Language Preference")}
                                <span>*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("Enter language preference")}
                                name="language_preference"
                                value={editForm?.values?.language_preference}
                                onChange={editForm.handleChange}
                                onBlur={editForm.handleBlur}
                            />
                            <CustomError name="language_preference" form={editForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Location")}
                                <span>*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("Enter location")}
                                name="address"
                                value={editForm?.values?.address}
                                onChange={editForm.handleChange}
                                onBlur={editForm.handleBlur}
                            />
                            <CustomError name="address" form={editForm} className="text-danger" />
                        </div>
                        {/* Submit Button */}
                        <div className="button-form">
                            <button type="submit" className={"btn btn-primary w-100" + (editSubmissionLoader ? " btn-loader" : "")}>
                                Update
                            </button>
                        </div>
                    </form>
                </Drawer.Body>
            </Drawer>
        </main>
    );
}
